import { baseUrl } from './env'

export default async(url = '', data = {}, type = 'GET', method = 'fetch',file = 'none') => {
  type = type.toUpperCase();
  url = baseUrl + url;

  if (type == 'GET') {
    let dataStr = ''; //数据拼接字符串
    Object.keys(data).forEach(key => {
      dataStr += key + '=' + data[key] + '&';
    })

    if (dataStr !== '') {
      dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
      url = url + '?' + dataStr;
    }
  }

let accessToken = '';
if(window.localStorage.getItem('manageLogin')!=null){
    let userData = JSON.parse(window.localStorage.getItem('manageLogin'));
    if (userData != null && typeof (userData) != 'undefined') {
          accessToken = userData.accessToken;
    }
}

  if (window.fetch && method == 'fetch') {
    let requestConfig = {
      credentials: 'include',
      method: type,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
        'responseType': 'arraybuffer',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Max-Age': 0,
        'Authorization': "Bearer "+accessToken,
      },
      mode: "cors",
      cache: "force-cache",
      responseType:'arraybuffer'
    }
    //console.log(data)
    if (type == 'POST') {
      Object.defineProperty(requestConfig, 'body', {
        value: JSON.stringify(data)
      })
    }

    try {
      if(file == 'returnURL'){
        return url
      }
      const response = await fetch(url, requestConfig);

      const responseJson = await response.json();
      //console.log(responseJson)
      // console.log("9999")
      return responseJson
    } catch (error) {
      // console.log("8888")
      throw new Error(error)
    }
  } else {
    return new Promise((resolve, reject) => {
      let requestObj;
      if (window.XMLHttpRequest) {
        requestObj = new XMLHttpRequest();
      } else {
        requestObj = new ActiveXObject;
      }

      let sendData = '';
      if (type == 'POST') {
        sendData = JSON.stringify(data);
      }

      if (type == 'GET') {
        sendData = JSON.stringify(data);
      }

      requestObj.open(type, url, true);
      requestObj.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      requestObj.send(sendData);

      requestObj.onreadystatechange = () => {
        if (requestObj.readyState == 4) {
          if (requestObj.status == 200) {
            let obj = requestObj.response
            if (typeof obj !== 'object') {
              obj = JSON.parse(obj);
            }
            resolve(obj)
          } else {
            reject(requestObj)
          }
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/config/fetch.js